<template>

    <div>
        <v-card min-height="350" align="center" class="transparent" elevation="0">

            <div align="center">
                <h2>About</h2>
            </div>

            <div class="mt-8">

                <v-card-text>
                    Bootware (ブートウェア) は、情報技術に関わる事業を行っております。

                    <br><br>IT アーキテクトとして PoC 案件への参画や、
                    フルスタックエンジニアリングの経験を持つ私が、お客様と共にミッションに挑みます。
                </v-card-text>
            </div>

        </v-card>
    </div>
</template>

<script>
    export default {
        name: "About"
    }
</script>

<style scoped>

</style>